import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { LoginHeader } from '../Common/LoginHeader';
import { Footer } from '../Common';
import Profile from '../../Models/Profile';
// import {connect} from 'react-redux';
// import {forgetPassword} from '../../../Action/forgetPassword';

class EnterPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id:false,
            password1:'',
            password2:'',
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        window.localStorage.removeItem('info');
        window.localStorage.removeItem('pro_pic');
        localStorage.clear();
        let code = this.props.match.params.code;
        Profile.checkLink(code).then(res => {
            if(res.data.status != 200){
                this.props.history.push('/invalid');
            }
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        e.preventDefault();
        document.getElementById("reset").disabled = true;
        let data = {}
        data = {
            password1:this.state.password1,
            password2:this.state.password2,
            code: this.props.match.params.code
        }
        if(this.state.password1 == '' &&  this.state.password2 == ''){
            document.getElementById("no_data").style.display = 'block';
            document.getElementById("no_matching").style.display = 'none';
            document.getElementById("reset").disabled = false;
        } else if(this.state.password1 != this.state.password2){
            document.getElementById("no_data").style.display = 'none';
            document.getElementById("no_matching").style.display = 'block';
            document.getElementById("reset").disabled = false;
        } else {
            Profile.ResetPass(data).then(res => {
                if(res.data.status == 200){
                    if(res.data.type == 1){
                        this.props.history.push('/login/buyer');
                    } else if(res.data.type == 2){
                        this.props.history.push('/login/seller');
                    } else {
                        this.props.history.push('/login/affiliator');
                    }
                } else {
                    alert("wrong");
                }
            })
        }

    }


    render() {
        return (
            <div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        {/* <div className="col-md-12"> */}
                        <div className="row mt-5">
                            <div className="col-md-12 tr_blank_big">
                                <div className="">

                                </div>
                            </div>
                            <div className="col-md-12 tr_blank_big">
                                <div className="">

                                </div>
                            </div>

                            <div className="col-md-12" style={{minHeight: "520px"}}>
                                <div className="row">
                                    <div className="col-md-3">
                                    </div>
                                    <div className="col-md-6 form-group ml-5">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="reg_first"  style={{borderBottom: "1px solid #e6e6e6"}}><b>{this.props.t('0')}</b></div>
                                            <div><br/></div>
                                            <div className="" style={{textAlign: "left"}}>
                                                <span>{this.props.t('1')}</span><br/>
                                                <input className="input_box" placeholder={this.props.t('2')} type="text" value={this.state.password1} onChange={this.updateValue.bind(this,'password1')} />
                                            </div>
                                            <div><br/></div>
                                            <div className="" style={{textAlign: "left"}}>
                                                <span>{this.props.t('3')}</span><br/>
                                                <input className="input_box" placeholder={this.props.t('2')} type="text" value={this.state.password2} onChange={this.updateValue.bind(this,'password2')} />
                                                <span id="no_matching" className="weighted_text" style={{color: "red", display: "none", fontSize: "12px"}}><b>{this.props.t('5')}</b></span><br/>
                                                <span id="no_data" className="weighted_text" style={{color: "red", display: "none", fontSize: "12px"}}><b>{this.props.t('6')}</b></span><br/>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div>&nbsp;</div>
                                            <div className="remember_text" style={{textAlign: "left", paddingLeft: "5%"}}>
                                                <button id="reset" type="submit" className="agree_button" onSubmit={this.handleSubmit.bind(this)}>{this.props.t('7')}</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-3">

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className=" mt-5" >
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = (state) => ({
//     forgetPassword: state.forgetPassword,
// });
// ForgetPassword=connect(mapStateToProps,{forgetPassword})(ForgetPassword);
export { EnterPassword };

 EnterPassword = withTranslation('src_Components_ResetPassword_EnterPassword')(EnterPassword);
